export enum LoginErrors {
  INVALID_TOKEN = "zxzlrsdhmqkfi",
  EMAIL_NOT_RECOGNIZED = "49nkomiqi8n6u",
  EMAIL_NOT_AUTHORIZED = "d6czr5rwp946f",
}
